'use client';
import React from 'react';

import { useTranslations } from 'next-intl';
import { Button } from '../../../_components/Button';
import { Link, useRouter } from '../../../../../navigation';

import {
	DialogContent,
	DialogTitle,
	DialogHeader,
	DialogDescription,
} from '@shadcn/components/ui/dialog';
import { TranslationsInfoType } from './page';
import { Course } from '../../../../../payload/payload-types';

export default function LanguageNotFoundDialog({
	translationsInfo,
	course,
}: {
	translationsInfo: TranslationsInfoType;
	course: Course;
}) {
	const router = useRouter();

	const t = useTranslations('Course');
	return (
		<DialogContent
			onOpenAutoFocus={e => e.preventDefault()}
			className="px-4 py-8 lg:px-16 lg:py-16"
		>
			<DialogHeader className="flex flex-col space-y-10">
				<DialogTitle className="mx-6 mt-10 mb-0 lg:mx-0 lg:mt-0">
					{t.rich('course-translations-missing-heading', {
						italic: chunks => <span className="italic">{chunks}</span>,
						courseTitle: course.title,
					})}
				</DialogTitle>
				<DialogDescription>
					{t('course-translations-missing-description')}
				</DialogDescription>
				<div className="flex flex-col items-center space-y-2 lg:flex-row lg:justify-center lg:space-y-0 lg:space-x-4">
					<Link href="/courses">
						<Button size="small" variant="outlined">
							{t('go-to-all-courses')}
						</Button>
					</Link>

					<Button
						onClick={e => {
							e.preventDefault();
							// @ts-expect-error course slug is valid path
							router.replace(`/courses/${course.slug}`, {
								locale: translationsInfo.hasLocaleFor,
							});
						}}
						size="small"
					>
						{t('switch-language')}
					</Button>
				</div>
			</DialogHeader>
		</DialogContent>
	);
}
